import { Component, Input } from '@angular/core';

/**
 * Text-Dot: EIN Orbi (Portal-Symbol `orbi`), solange KI-Text geschrieben
 * wird — sucht mit den Augen, hüpft ein Stück nach rechts und zurück,
 * blinzelt (3,6s). Steht dort, wo der Text erscheint (am Ende des wachsenden
 * Texts bzw. im noch leeren Textfeld).
 *
 * Abgrenzung (Ladezustände-Regel, CLAUDE.md Regel 19): wird auf etwas
 * anderes als Text gewartet (Daten, Übung, Kurs, Sync, Suche), zeigt man den
 * Loader mit drei Orbis (`app-orbi-loader`).
 *
 * Farbe = `currentColor` — der Aufrufer setzt `color` passend zur Fläche.
 * Gleiche Komponente im chat-widget (`components/orbi-text-dot`), dort hinter der gestreamten Antwort.
 */
@Component({
  selector: 'app-orbi-text-dot',
  templateUrl: './orbi-text-dot.component.html',
  styleUrls: ['./orbi-text-dot.component.scss'],
  host: { 'aria-hidden': 'true' },
})
export class OrbiTextDotComponent {
  /** Kantenlänge in px. */
  @Input() size = 18;
}
